import styled, { css } from 'styled-components'
import { WrapperChipProps } from './interfaces'

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.km4};

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-wrap: wrap;
  }
`

export const Subtitle = styled.div`
  padding: ${({ theme }) => theme.spacing.km2} ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km5};
`

export const WrapperTextField = styled.div`
  width: 450px;

  input {
    background-color: ${({ theme }) => theme.color.background.neutral.weak};
    border: unset;
  }

  #input-icons {
    background-color: ${({ theme }) => theme.color.background.neutral.weak};
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const WrapperChip = styled.div<WrapperChipProps>`
  position: relative;
  fuel-chip {
    div {
      label {
        height: ${({ theme }) => theme.spacing.km8};

        @media (max-width: 768px) {
          height: ${({ theme }) => theme.spacing.km10};
        }
      }
    }
  }

  ${({ $width }) =>
    $width
      ? css`
          width: ${$width};
          fuel-chip {
            width: 100%;
            div {
              width: 100%;
              label {
                justify-content: center;
              }
            }
          }
        `
      : {}};
`

export const PopoverOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km4};
`
